import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const Button = ({ children, to, href, onClick, className = '', showArrow = false, type = 'button', disabled = false }) => {
  const baseStyle = "inline-flex items-center justify-center gap-3 px-6 py-3 bg-brand-text text-brand-bg font-inter font-medium text-sm tracking-wide transition-transform hover:scale-[0.98] active:scale-95";

  const content = (
    <>
      {children}
      {showArrow && <SafeIcon icon={FiArrowRight} className="text-lg" />}
    </>
  );

  if (to) {
    return <Link to={to} onClick={onClick} className={`${baseStyle} ${className}`}>{content}</Link>;
  }

  if (href) {
    return <a href={href} onClick={onClick} className={`${baseStyle} ${className}`}>{content}</a>;
  }

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`${baseStyle} ${disabled ? 'opacity-60 pointer-events-none' : ''} ${className}`}>
      {content}
    </button>
  );
};

export default Button;